"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modelBuilder = void 0;
const deepCopy_1 = require("../deep-copy/deepCopy");
/**
 * Function to return a `Model` to for a service. The returned model class is used
 * to store objects of a set shape, upon construction any extraneous fields (whos keys are not
 * specified in the `defaultModelValues` param) will be discarded. Therefore
 * ***it is important to make sure all your models keys are contained in `defaultModelValues` param to this function***
 * even if they only have `undefined` as the value. If you miss a key from `defaultModelValues`
 * this will never get added to your model class, regardless of if you pass valid values
 * to the `Model` constructor.
 *
 * The main purpose of function, over the standard `Model` class (which was/is exported from the
 * service framework) is to avoid the need to duplicate types on an interface and in your model class.
 *
 * **Example usage:**
 * ```ts
 * // define the TS type for the raw object
 * interface UserI {
 *      userId: string,
 *      age: number,
 *      numberOfFriends?: number
 * }
 *
 * // define the default values for any fields that are not passed to your model
 * const defaultUser = {
 *      userId: undefined,
 *      age: undefined,
 *      numberOfFriends: 0
 * }
 *
 * export default const User = modelBuilder<UserI>(defaultUser)
 * ```
 */
function modelBuilder(defaultModelValues) {
    // Make a shallow copy here incase the service code mutates defaultModelValues at some point later
    // Can't do a deepCopy (using JSON.stringify at least) becuase JSON.stringify strips out `undefined` values
    // which we need to preserve
    const defaultModelValuesCopy = Object.assign({}, defaultModelValues);
    return class {
        constructor(fields) {
            Object.assign(this, defaultModelValuesCopy);
            this.mapKeysToClass(fields);
        }
        /**
         * Returns an object with all the default values for your model.
         */
        static getDefaultModelValues() {
            return Object.assign({}, defaultModelValuesCopy);
        }
        mapKeysToClass(map) {
            if (map) {
                Object.keys(this).forEach(key => {
                    if (map[key] !== undefined) {
                        this[key] = (0, deepCopy_1.deepCopy)(map[key]);
                    }
                });
            }
        }
    };
}
exports.modelBuilder = modelBuilder;
